export enum FilterItemType {
  Dropped = 'Dropped',
  PrivateSeller = 'PrivateSeller',
  PendingDelete = 'Pending Delete',
  PreRelease = 'PreRelease',
  KeywordContains = 'Contains',
  KeywordStartsWith = 'StartsWith',
  KeywordEndsWith = 'EndsWith',
  Min = 'min',
  Max = 'max',
  COM = 'com',
  ORG = 'org',
  NET = 'net',
  CC = 'cc',
  TV = 'tv',
  IO = 'io',
  INFO = 'info',
  AuctionsEndingToday = 'AuctionsEndingToday',
  AuctionWithBids = 'AuctionsWithBids',
  NoDashes = 'NoDashes',
  AllNumbers = 'AllNumbers',
  NoNumbers = 'NoNumbers',
  NoReserve = 'NoReserve',
  ReserveMet = 'ReserveMet'
}
